import React from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import NumberFormatCustom from '../common/form/NumberFormatCustom';

const YearGoalForm = ({ formik, onAutoDisHandler }) => {

    return (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
            noValidate
            autoComplete="off"
            onSubmit={formik.handleSubmit}
            onAutoDisHandler={onAutoDisHandler}
            >

            <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
                sx={{ p: 1, borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
            >
                <Grid item xs={2} align="right"><FormLabel><Typography variant="subtitle2" component="span">총목표매출</Typography><Typography variant="subtitle2" component="span" sx={{ color: 'error.main' }}>(필수)</Typography></FormLabel></Grid>
                <Grid item xs={4}>
                    <TextField
                        size="small"
                        required={true}
                        variant="outlined"
                        fullWidth
                        id="ptargetSales"
                        name="ptargetSales"
                        value={formik.values.ptargetSales}
                        onChange={formik.handleChange}
                        error={formik.touched.ptargetSales && Boolean(formik.errors.ptargetSales)}
                        helperText={formik.touched.ptargetSales && formik.errors.ptargetSales}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                    />
                </Grid>
                <Grid item xs={2} align="right"><FormLabel><Typography variant="subtitle2" component="span">총매출이익</Typography><Typography variant="subtitle2" component="span" sx={{ color: 'error.main' }}>(필수)</Typography></FormLabel></Grid>
                <Grid item xs={4}>
                    <TextField
                        size="small"
                        required={true}
                        variant="outlined"
                        fullWidth
                        id="ptargetSalesProfit"
                        name="ptargetSalesProfit"
                        value={formik.values.ptargetSalesProfit}
                        onChange={formik.handleChange}
                        error={formik.touched.ptargetSalesProfit && Boolean(formik.errors.ptargetSalesProfit)}
                        helperText={formik.touched.ptargetSalesProfit && formik.errors.ptargetSalesProfit}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                    />
                </Grid>

            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    m: 1
                }}
            >
                <Button
                    sx={{ mx: 1 }}
                    variant="contained"
                    onClick={() => onAutoDisHandler(formik.values.ptargetSales, formik.values.ptargetSalesProfit)}
                >
                    자동배분
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={formik.isSubmitting}
                >
                    저장
                </Button>
            </Box>
        </Box>
    )
}

export default YearGoalForm